"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Atom = /** @class */ (function () {
    function Atom(type, name, value) {
        this.name = "unknow";
        this.setType(type);
        this.setName(name);
        this.setValue(value);
    }
    ;
    Atom.prototype.setType = function (type) {
        this.type = type;
    };
    ;
    Atom.prototype.setName = function (name) {
        this.name = name;
    };
    ;
    Atom.prototype.setValue = function (value, lockType) {
        if (typeof lockType === "undefined") {
            lockType = true;
        }
        if (lockType && typeof value !== this.type && this.type !== "Array") {
            if (this.type === "string") {
                return this.setValue(String(value));
            }
            else if (this.type === "number") {
                return this.setValue(Number(value));
            }
            else if (this.type === "boolean") {
                return this.setValue(Boolean(value));
            }
            else if (this.type === "null") {
                return this.setValue(null);
            }
            else if (this.type === "undefined") {
                return this.setValue(0);
            }
            else if (this.type === "Array") {
                return this.setValue([], false);
            }
        }
        this.value = [];
        if (typeof value === "string") {
            this.setType("string");
            for (var i = 0; i < value.length; i++) {
                this.value.push(value.charCodeAt(i));
            }
        }
        else if (typeof value === "number") {
            this.setType("number");
            this.value.push(value);
        }
        else if (typeof value === "boolean") {
            this.setType("boolean");
            this.value.push(value ? 1 : 0);
        }
        else if (value === null) {
            this.setType("null");
            this.value.push(0);
        }
        else if (value === void 0) {
            this.setType("undefined");
            this.value.push(0);
        }
        else if (value instanceof Atom) {
            this.setType("Array");
            this.children = [value];
        }
        else if (value instanceof Array) {
            this.setType("Array");
            this.children = value;
        }
    };
    ;
    Atom.prototype.appendValue = function (value) {
        if (this.type === "Array") {
            this.children.push(value);
        }
    };
    Atom.prototype.toString = function () {
        switch (this.type) {
            case "string":
                return this.value.map(function (v) { return String.fromCharCode(v); }).join("");
            case "number":
                return String(this.value[0] || "");
            case "boolean":
                return this.value[0] === 1 ? "true" : "false";
            case "null":
                return "null";
            case "undefined":
                return "undefined";
            case "Array":
                return this.children.map(function (child) { return child.toString(); }).join("");
            default:
                return this.type;
        }
    };
    Atom.prototype.toNumber = function () {
        switch (this.type) {
            case "string":
                return Number(this.toString());
            case "number":
            case "boolean":
                return this.value[0];
            case "Array":
                if (this.children.length > 1)
                    return NaN;
                if (this.children.length === 0)
                    return 0;
                if (this.children.length === 1)
                    return this.children[0].toNumber();
                return Number(this.value);
            case "null":
                return 0;
            case "undefined":
                return NaN;
            default:
                return NaN;
        }
    };
    Atom.prototype.toBoolean = function () {
        return this.type === "Array" ? true : Boolean(this.value[0]);
    };
    Atom.prototype.getChild = function (index) {
        if (!this.children || index >= this.children.length) {
            return new Atom("undefined", String(index));
        }
        else {
            return this.children[index];
        }
    };
    Atom.prototype.equal = function (value) {
        var isTrue = false;
        if (this.type === value.type) {
            switch (this.type) {
                case "Array":
                    if (this.children === value.children) {
                        isTrue = true;
                    }
                    break;
                case "string":
                    if (this.value.length === value.value.length) {
                        isTrue = true;
                        for (var i = 0; i < this.value.length; i++) {
                            if (this.value[i] !== value.value[i]) {
                                isTrue = false;
                                break;
                            }
                        }
                    }
                    break;
                default:
                    isTrue = this.value[0] === value.value[0];
            }
        }
        return new Atom("boolean", "unknow", isTrue);
    };
    return Atom;
}());
exports.Atom = Atom;
var FunctionAtom = /** @class */ (function (_super) {
    __extends(FunctionAtom, _super);
    function FunctionAtom() {
        return _super.call(this, "function", "anonymous", "") || this;
    }
    return FunctionAtom;
}(Atom));
function variableToBaseType(variables, result) {
    if (!result)
        result = new Atom("Array", "window", []);
    if (!variables)
        return result;
    for (var key in variables) {
        if (variables.hasOwnProperty(key)) {
            var typeName = typeof variables[key];
            if (typeName !== null && typeName === "object") {
                result.appendValue(variableToBaseType(variables[key], new Atom("Array", key, [])));
            }
            else {
                result.appendValue(new Atom(typeName, key, variables[key]));
            }
        }
    }
    return result;
    /*return variables.map(variable=>{
        if(variable.type==="string")return new StringType(variable.name,variable.value);
        if(variable.type==="number")return new NumberType(variable.name,variable.value);
        if(variable.type==="boolean")return new BooleanType(variable.name,variable.value);
        if(variable.type==="array"){
            if("children" in variable && "name" in variable){
                return new ArrayType(variable["name"],variableToBaseType(variable["children"]));
            }
            return new ArrayType(variable.name,variableToBaseType([]));
        }
        if(variable.type==="null")return new NullType(variable.name,variable.value);
        return new UndefinedType(variable.name,variable.value);
    })*/
}
exports.variableToBaseType = variableToBaseType;
function getVariable(name, variable) {
    if (variable.name === name)
        return variable;
    var result = new Atom("undefined", name);
    var path = name.split(".");
    var index = 0;
    var _vars = variable.children;
    while (index < path.length) {
        for (var i = 0; i < _vars.length; i++) {
            if (_vars[i].name === path[index]) {
                result = _vars[i];
                _vars = _vars[i].children;
                break;
            }
        }
        index++;
    }
    return result;
}
exports.getVariable = getVariable;
